<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />

    <!-- Breadcrumb y ayuda -->
    <div class="mb-3">
      <div class="row">
        <div class="col-11">
          <div class="breadcrumb-container">
            <router-link to="/tramite-carga">Trámites</router-link>
            > Trámite {{ datoTramite.idTramite }}
          </div>
        </div>
        <div class="col-1">
          <span
            class="material-symbols-outlined"
            style="font-size: 32px; color: blue; cursor: pointer"
            @click="showModalHelp = true"
          >
            help
          </span>
        </div>
      </div>
    </div>
<!--
    <Modal v-model:modelValue="showModalHelp">
      <AyudaTramiteForm />
    </Modal>
-->
    <hr />

    <!-- Modal de Tramite -->
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div style="text-align: right">
          <button @click.prevent="mostrarOcultarBloque">
            {{
              mostrarBloque ? "(-) Menos información" : "(+) Más información"
            }}
          </button>
        </div>
        <div v-if="mostrarBloque" class="mb-3">
<p v-if="datoTramite.estadoTramite === 'DOCUMENTADO'" class="alert alert-warning">
  El trámite se encuentra en estado <strong>DOCUMENTADO</strong>, lo que indica que existen atenciones sin documentación de respaldo. Verifique la opción <strong>“Atenciones médicas sin documentación cargada”.</strong>
</p>
          <form>
            <div class="modal-body">
              <!-- Campos del Tramite -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-1">
                    <label for="idTramite" class="form-label fw-bold">Número</label>
                  </div>
                  <div class="col-3">
                    <input
                      type="text"
                      class="form-control"
                      id="idTramite"
                      name="idTramite"
                      v-model="datoTramite.idTramite"
                      disabled
                    />
                  </div>
                  <div class="col-2">
                    <label for="fechaReg" class="form-label fw-bold"
                      >Fecha de registro</label
                    >
                  </div>
                  <div class="col-2">
                    <input
                      type="text"
                      class="form-control"
                      id="fechaReg"
                      name="fechaReg"
                      :value="getFormattedDate(datoTramite.fechaReg)"
                      disabled
                    />
                  </div>
                  <div class="col-1">
                    <label for="estadoTramite" class="form-label fw-bold">Estado</label>
                  </div>
                  <div class="col-3">
                    <input
                      type="text"
                      class="form-control"
                      id="estadoTramite"
                      name="estadoTramite"
                      v-model="datoTramite.estadoTramite"
                      disabled
                    />
                  </div>
                </div>
              </div>

              <!-- Prestador -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-1">
                    <label for="nombreComercial" class="form-label fw-bold"
                      >Prestador</label
                    >
                  </div>
                  <div class="col-7">
                    <input
                      type="text"
                      class="form-control"
                      id="nombreComercial"
                      name="nombreComercial"
                      v-model="datoTramite.nombreComercial"
                      disabled
                    />
                  </div>
                  <div class="col-1">
                    <label for="numSemana" class="form-label fw-bold">Semana</label>
                  </div>
                  <div class="col-3">
                    <input
                      type="text"
                      class="form-control"
                      id="numSemana"
                      name="numSemana"
                      :value="
                        datoTramite.numSemana === 0 ? '' : datoTramite.numSemana
                      "
                      disabled
                    />
                  </div>
                </div>
              </div>

              <!-- Selección de Servicio -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-1">
                    <label for="idServicio" class="form-label fw-bold">Servicio</label>
                  </div>
                  <div class="col-3">
                    <input
                      type="text"
                      class="form-control"
                      id="servicioNombre"
                      name="servicioNombre"
                      v-model="datoTramite.servicioNombre"
                      disabled
                    />
                  </div>
                  <div class="col-2">
                    <label for="fechaDesde" class="form-label fw-bold"
                      >Fecha desde</label
                    >
                  </div>
                  <div class="col-2">
                    <input
                      type="date"
                      class="form-control"
                      id="fechaDesde"
                      name="fechaDesde"
                      :disabled="
                        this.datoTramite.estadoTramite !== 'REGISTRADO'
                      "
                      v-model="datoTramite.fechaDesde"
                      required
                    />
                  </div>
                  <div class="col-2">
                    <label for="fechaHasta" class="form-label fw-bold"
                      >Fecha hasta</label
                    >
                  </div>
                  <div class="col-2">
                    <input
                      type="date"
                      class="form-control"
                      id="fechaHasta"
                      name="fechaHasta"
                      :disabled="
                        datoTramite.estadoTramite !== 'REGISTRADO'
                      "
                      v-model="datoTramite.fechaHasta"
                      required
                    />
                  </div>
                </div>
              </div>

              <!-- Selección de Servicio -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-1">
                    <label for="idServicio" class="form-label fw-bold">Asegurador</label>
                  </div>
                  <div class="col-8">
                    <input
                      type="text"
                      class="form-control"
                      id="aseguradorNombre"
                      name="aseguradorNombre"
                      v-model="datoTramite.aseguradorNombre"
                      disabled
                    />
                  </div>
                  <div class="col-1">
                    <label for="idServicio" class="form-label fw-bold">Inicial</label>
                  </div>
                  <div class="col-2">
                    <input
                      type="text"
                      class="form-control"
                      id="inicial"
                      name="inicial"
                      :value="datoTramite.inicial === 1 ? 'Sí' : datoTramite.inicial === 0 ? 'No' : ''"
                      disabled
                    />
                  </div>
                </div>
              </div>

              <!-- Descripción -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-1">
                    <label for="descripcion" class="form-label fw-bold"
                      >Descripción</label
                    >
                  </div>
                  <div class="col-11">
                    <textarea
                      class="form-control"
                      id="descripcion"
                      name="descripcion"
                      v-model="datoTramite.descripcion"
                      style="text-transform: uppercase"
                      :disabled="
                        this.datoTramite.estadoTramite !== 'REGISTRADO'
                      "
                    >
                    </textarea>
                  </div>
                </div>
              </div>
            </div>
          </form>

          <div
            class="modal-footer"
            :disabled="datoTramite.estadoTramite == 'ENVIADO'"
          >
            <div class="me-auto">
              <button
                v-if="(datoTramite.numSemana === 0 || (datoTramite.numSemana ) < datoTramite.maxSemanas) && (showTable === 'cargaDatos' && datoTramite.frecuenciaCarga === 'S')"
                type="submit"
                class="btn btn-outline-primary"
                @click="actualizarSemana"
                :title="'Saltar semana ' + (datoTramite.numSemana + 1)"
              >
                <span
                  class="material-symbols-outlined"
                  style="font-size: 24px; color: orangered; cursor: pointer"
                  >skip_next</span
                >
                Saltar semana {{ datoTramite.numSemana + 1 }}
              </button>
              <button
                type="button"
                class="btn btn-outline-primary"
                @click.prevent="autorizaciones"
                title="Autorización para modificación y carga de archivos"
                v-if="botonAutorizaciones"
              >
                <span class="material-symbols-outlined" style="font-size: 24px"
                  >news</span
                >
                Solicitudes para modificación y carga de archivos
              </button>
              &nbsp;
              <button
                type="button"
                class="btn btn-outline-primary"
                @click.prevent="observaciones"
                title="Observaciones"
                v-if="botonAutorizaciones"
              >
                <span
                  class="material-symbols-outlined"
                  style="font-size: 24px; cursor: pointer"
                  >clinical_notes</span
                >
                Observaciones
              </button>
              &nbsp;
<button
  type="button"
  class="btn btn-outline-primary"
  @click.prevent="cargarPDFs"
>
  <span class="material-symbols-outlined" style="font-size: 24px; cursor: pointer">upload_file</span>
  Cargar e Indexar PDFs
</button>
            </div>
            <button
              type="button"
              class="btn btn-outline-primary"
              @click.prevent="guardarTramite"
              title="Actualizar"
              v-if="
                datoTramite.estadoTramite == 'REGISTRADO' ||
                datoTramite.tieneApr == 1
              "
            >
              <i
                class="material-icons"
                style="font-size: 24px; color: orangered; cursor: pointer"
                >update</i
              >
              Actualizar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Estructura de Tabs -->
    <div class="tabs">
      <button
        class="tablink"
        @click="showTable = 'cargaDatos'"
        :class="{ 'active-tab': showTable === 'cargaDatos' }"
      >
        Carga de datos y archivos
      </button>
<!--
      <button
        class="tablink"
        @click="showTable = 'cargaDatosS3'"
        :class="{ 'active-tab': showTable === 'cargaDatosS3' }"
      >
        Carga de datos y archivos (planos)
      </button>
-->
      <button
        class="tablink"
        @click="showTable = 'planilla'"
        :class="{ 'active-tab': showTable === 'planilla' }"
      >
        Atenciones médicas
      </button>

      <button
        class="tablink"
        @click="showTable = 'sinArchivos'"
        :class="{ 'active-tab': showTable === 'sinArchivos' }"
      >
        Atenciones médicas sin documentación cargada
      </button>

      <button
        class="tablink"
        @click="showTable = 'supervision'"
        :class="{ 'active-tab': showTable === 'supervision' }"
      >
        Supervisión
      </button>

      <button
        class="tablink"
        @click="showTable = 'utilidades'"
        :class="{ 'active-tab': showTable === 'utilidades' }"
      >
        Utilidades
      </button>
  
    </div>

    <!-- Contenido dinámico según la pestaña seleccionada -->

    <div v-if="showTable === 'cargaDatos' && datoTramite.frecuenciaCarga === 'S'">
      <CargaSemana
        :p_idTramite="Number(p_idTramite)"
        :p_numSemana="datoTramite.numSemana"
        :p_maxSemana="datoTramite.maxSemanas"
        @estadoTramite="handleEstadoTramite"
        @actualizarTramite="handleActualizarTramite"
      >
      </CargaSemana>
    </div>
<!--
    <div v-if="showTable === 'cargaDatosS3' && datoTramite.frecuenciaCarga === 'S'">
      <CargaSemana
        :p_idTramite="Number(p_idTramite)"
        :p_numSemana="datoTramite.numSemana"
        :p_maxSemana="datoTramite.maxSemanas"
        @estadoTramite="handleEstadoTramite"
        @actualizarTramite="handleActualizarTramite"
      >
      </CargaSemana>
    </div>
-->
    <div v-if="showTable === 'cargaDatos' && datoTramite.frecuenciaCarga === 'M'">
      <CargaMes
        :p_idTramite="p_idTramite"
		:p_idAutorizacion="p_idAutorizacion"
		:p_frecuenciaCarga="datoTramite.frecuenciaCarga"
        @estadoTramite="handleEstadoTramite"
        @actualizarTramite="handleActualizarTramite"
      >
      </CargaMes>
    </div>

    <div v-if="showTable === 'planilla'">
      <Planilla :p_tramite="datoTramite"></Planilla>
    </div>

    <div v-if="showTable === 'sinArchivos'">
      <TramitesPlaSinArchivos
        :p_idtramite="p_idTramite"
      ></TramitesPlaSinArchivos>
    </div>

    <div v-if="showTable === 'supervision'">
      <PlanillaSupervision :p_tramite="datoTramite"></PlanillaSupervision>
    </div>

    <div v-if="showTable === 'utilidades'">
      <TramiteCargaUtilidades
        :idTramite="Number(p_idTramite)"
        :idUsuario="Number(p_idUsuario)"
      />
    </div>

    <Footer />

  </div>
</template>

<script>
import Layout from "@/components/Layout.vue";
import Footer from "@/components/Footer.vue";
import TramiteCargaUtilidades from "@/components/TramiteCargaUtilidades.vue";
import api from "@/services/api";
import { validarForm } from "@/modules/validacionesForms.js";
import dateFormat from "@/modules/dateFormat.js";
import CargaSemana from "@/views/forms/CargaSemana.vue";
import CargaMes from "@/views/forms/CargaMes.vue";
import Planilla from "@/views/forms/Planilla.vue";
import PlanillaSupervision from "@/views/forms/PlanillaSupervision.vue";
import TramitesPlaSinArchivos from "@/views/reportes/TramitesPlaSinArchivos.vue";

//import { format } from 'date-fns';

import * as $ from "jquery";
window["$"] = $;
window["jQuery"] = $;
import Swal from "sweetalert2";

export default {
  components: {
    Layout,
    Footer,
    CargaSemana,
    CargaMes,
    Planilla,
    PlanillaSupervision,
    TramitesPlaSinArchivos,
    TramiteCargaUtilidades,
  },
  data() {
    return {
      datoTramite: {},
      p_idTramite: 0,
      p_idUsuario: 0,
      p_idAutorizacion: null,
      showTable: "cargaDatos", // Pestaña por defecto
      mostrarBloque: true,
      numeroCargas: 0,
      showModalCargarPDFs: false,
    };
  },
  computed: {
    botonAutorizaciones() {
      return (
//        this.datoTramite.estadoTramite === "RECIBIDO" ||
//        this.datoTramite.estadoTramite === "EN PROCESO" ||
//        this.datoTramite.estadoTramite === "OBSERVACIONES" ||
        this.numeroCargas > 1
      );
    },
  },
  async mounted() {
    this.p_idTramite = this.$route.params.p_idtramite;
    this.p_idUsuario = window.sessionStorage.getItem("idUsuario");
    await this.getData();
    this.fetchCount();
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
    //    this.fetchServicios()
    //    this.fetchPlantillas()
  },
  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    mostrarOcultarBloque() {
      this.mostrarBloque = !this.mostrarBloque;
    },
    handleEstadoTramite(value) {
      this.datoTramite.estadoTramite = value;
    },
    handleActualizarTramite(value) {
      if (value) {
        this.getData();
      }
    },
    async getData() {
      await api.get(`/vwtramites/${this.p_idTramite}`)
        .then((response) => {
          this.datoTramite = response.data;
          this.datoTramite.fechaDesde = dateFormat.getFormattedDateISO(
            this.datoTramite.fechaDesde
          );
          this.datoTramite.fechaHasta = dateFormat.getFormattedDateISO(
            this.datoTramite.fechaHasta
          );
        })
        .catch((error) => {
          console.error("Error al obtener datos del trámite:", error);
        });
    },
    async fetchCount() {
      try {
        const response = await api.get("/vwcargas/count/" + this.p_idTramite
        );
        this.numeroCargas = response.data;
      } catch (error) {
        console.error("Error al obtener el conteo:", error);
      }
    },
    validarForm() {
      const requiredFields = [
        "idPrestador",
        "idServicio",
        "fechaDesde",
        "fechaHasta",
        "descripcion",
      ];
      const requiredFieldsText = [
        "idPrestador",
        "idServicio",
        "fechaDesde",
        "fechaHasta",
        "descripcion",
      ];
      return validarForm(this.datoTramite, requiredFields, requiredFieldsText);
    },
    async guardarTramite() {
      if (this.validarForm() === 1) {
        try {
          await api.post("/tramites/" +
              window.sessionStorage.getItem("idUsuario"),
            this.datoTramite
          );
          Swal.fire(
            "Correcto!",
            "Trámite actualizado exitosamente!",
            "success"
          );
        } catch (error) {
          Swal.fire("Error!", "Inténtelo de nuevo!", "error");
        }
      }
    },
    async actualizarSemana() {
      if (this.validarForm() === 1) {
        this.datoTramite.numSemana = this.datoTramite.numSemana + 1;
        try {
          await api.post("/tramites/" +
              window.sessionStorage.getItem("idUsuario"),
            this.datoTramite
          );
          Swal.fire(
            "Correcto!",
            "Ya puedes cargar la siguiente semana!",
            "success"
          );
        } catch (error) {
          Swal.fire("Error!", "Inténtelo de nuevo!", "error");
        }
      }
    },
    autorizaciones() {
        this.$router.push(
          "/autorizacion-tramite/" + this.p_idTramite
        );
    },
    observaciones() {
      this.$router.push(
        "/planillas-observaciones/" + this.datoTramite.idTramite
      );
    },
    indexacion() {
      this.$router.push(
        "/indexador/" + this.datoTramite.idTramite
      );
    },
    cargarPDFs() {
      this.$router.push("/cargar-indexar-pdfs/" + this.p_idTramite);
    },
  },
};
</script>

<style src="@/assets/css/tabs.css" scoped></style>
<style scoped>
.upload-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 90%;
  margin: 10px auto;
  padding: 15px;
  border: 2px solid #ccc;
  border-radius: 12px;
  background-color: #f7f9fc;
}

.row.align-items-center {
  display: flex;
  align-items: center;
}

.text-end {
  text-align: right;
}
</style>

<style scoped>
.input-group {
  display: flex;
  gap: 10px;
  align-items: center;
}
</style>

<style scoped>
.btn {
  font-size: 16px;
  padding: 10px 20px;
}

.alert {
  margin-top: 20px;
  padding: 10px;
  border-radius: 5px;
}

.alert-success {
  color: #155724;
  background-color: #d4edda;
  border-color: #c3e6cb;
}

.alert-danger {
  color: #721c24;
  background-color: #f8d7da;
  border-color: #f5c6cb;
}
</style>
<style scoped>
.centrado {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100h; /* Usa viewport height para ocupar toda la pantalla */
}
</style>

<style scoped>
.csv-to-json-container {
  max-width: 500px;
  margin: 2rem auto;
  padding: 1rem;
}

.form-group {
  margin-bottom: 1rem;
}

label {
  display: block;
  margin-bottom: 0.5rem;
}

input[type="number"],
input[type="file"] {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
}
/*
button {
  padding: 0.75rem 1.5rem;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

button:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
}
*/
.error-message {
  color: red;
  margin-top: 1rem;
}

.success-message {
  color: green;
  margin-top: 1rem;
}

</style>
<style scoped>
.error-message { color: red; margin-top: 1rem; }
.success-message { color: green; margin-top: 1rem; }
</style>